<!--
  This page displays an error message and is called from
  \App\Exceptions\Handler@inertiaResponse

  It does not appear very often because Inertia calls are currently only used
  during the login/logout process.
-->
<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-alert
          type="error"
          max-width="480"
          class="mx-auto"
          :icon="icons.error"
        >
          {{ message }}
          <div class="mt-3 text-right">
            <v-btn
              icon
              @click="reload()"
            >
              <v-icon v-text="icons.reload" />
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import layout from '@/Layouts/Auth'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    layout,

    mixins: [
      UsesIcons,
    ],

    props: {
      code: {
        type: Number,
        required: true,
      },
      message: {
        type: String,
        required: true,
      },
    },

    methods: {
      reload () {
        window.location.reload()
      },
    },
  }
</script>
